module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi3-2553e48b25aaf85b67ed25479ec48d08.png";